import { Box, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { GroupWork } from "@mui/icons-material";
import React, { ReactElement } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TenantsCard = (): ReactElement => {
    const history = useHistory();
    const { t } = useTranslation("common");

    return <Box display="flex" justifyContent="end">
        <Card sx={{ textAlign: "center", borderRadius: 10 }}>
            <CardActionArea
                sx={{ width: 370, minHeight: 280, padding: 2 }}
                onClick={() => history.push("/tenants")}>
                <GroupWork sx={{ fontSize: 50 }} />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        {t('home.tenants')}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {t('home.tenants_details')}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    </Box>
}

export default TenantsCard